import React, { useEffect, useRef, useState } from "react";
import {
    Layout,
    Menu,
    Button,
    Typography,
    message, 
    notification
} from "antd";

import { Link, useHistory } from "react-router-dom";
import {
    DribbbleOutlined,
    TwitterOutlined,
    InstagramOutlined,
    GithubOutlined,
} from "@ant-design/icons";

import AirplaneIcon from '../assets/images/airplane.png';
import CarIcon from '../assets/images/car.png';
import TourismIcon from '../assets/images/tourism.png';
import Summary from "../components/forms/Summary";
import MapWithRoute from "../components/maps/MapWithRoute";

import { loadStripe } from '@stripe/stripe-js';
import { getVehiclesTypes } from "../api/vehicles-type.service";
import { getAddOns } from "../api/add-on.service";
import CurrencySelector from "../context/CurrencySelector";

import SawariLogo from '../assets/sawari-logo.png';
import HeaderBar from "./HeaderBar";
import Footerbar from "../sections/Footerbar";


const { Title } = Typography;
const { Header, Footer, Content } = Layout;

export default function Confirmation() {

    const history = useHistory()

    const [current, setCurrent] = useState(0);
    const [directions, setDirections] = useState(null);
    const [totalDistance, setTotalDistance] = useState(0);
    const [totalDuration, setTotalDuration] = useState(0);
    const [amount, setAmount] = useState(0);

    const [directionsReturn, setDirectionsReturn] = useState(null);
    const [totalDistanceReturn, setTotalDistanceReturn] = useState(0);
    const [totalDurationReturn, setTotalDurationReturn] = useState(0);

    const [driversInstructions, setDriversInstructions] = useState("");
    const [driversInstructionsReturn, setDriversInstructionsReturn] = useState("");

    const [formData, setFormData] = useState({
        passengerCount: 1,
        luggageCount: '',
        returnPassengerCount: 1,
        returnLuggageCount: '',
        type: 'oneway',
        pickupType: 'airport',
        additionalPickupType: ['address'],
        returnAdditionalPickupType: ['address'],
        destinationType: 'address',
        returnPickupType: 'airport',
        returnDestinationType: 'address',
        additionalPickups: [],
        returnAdditionalPickups: [],
    }); // To store form data

    const [additionalPickupType, setAdditionalPickupType] = useState(formData.additionalPickupType);
    const [returnAdditionalPickupType, setReturnAdditionalPickupType] = useState(formData.returnAdditionalPickupType);

    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [selectedVehicleReturn, setSelectedVehicleReturn] = useState(null);

    const [onewayMinutes, setOnewayMinutes] = useState(0);
    const [returnMinutes, setReturnMinutes] = useState(0);
    const [summaryObj, setSummaryObj]= useState({})

    const contentStyle = {
        textAlign: 'center',
        color: "#00803e",
        backgroundColor: "white",
        borderRadius: "8px",
        border: 'none',
        marginTop: 16,
        padding: '1rem',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'
    };

    useEffect(() => {
        setSummaryObj(JSON.parse(localStorage.getItem("summaryObj")))
    }, [])

    return (
        <>
            <div className="layout-default ant-layout layout-sign-up">
            <HeaderBar/>

                <div className="landing-header absolute w-full z-0" style={{
                    position: 'absolute',
                    width: '100%',
                    zIndex: 0
                }}>
                    <div className="content">
                        <Title style={{ color: 'black' }}>Confirmation</Title>
                    </div>
                </div>

                <div className="p-0 my-16 mx-24" style={{
                    zIndex: 20,
                    marginTop: '11rem'
                }}>
                    <div style={contentStyle}>{
                        (
                            <div>
                                <Summary title="Your Booking is confirmed" description="An email with all the details has been sent at registered email address" showInstructions={false} setAmount={setAmount} rideFareReturn={summaryObj.rideFareReturn} rideFare={summaryObj.rideFare} setDriversInstructions={setDriversInstructions} setDriversInstructionsReturn={setDriversInstructionsReturn} data={{
                                    ...summaryObj, isFinal: true
                                }}
                                    mapReturn={null}
                                    map={null} />
                            </div>
                        )
                    }</div>
                    <div style={{ marginTop: 24 }} className="flex justify-end">
                        {(
                            <Button type="primary" style={{ backgroundColor: '#00803e', borderColor: '#00803e' }}
                            onClick={() => {
                                history.push('/')
                            }}>
                                Go to Home page
                            </Button>
                        )}
                    </div>
                </div>
                <Footerbar bgColorClass="bg-neutral-light" />
            </div>
        </>
    );
}